import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'
import {
  GetMarketplaceListingFeatureTypeIdsV2,
  GetMarketplaceListingFeatureTypeIdsV2Variables
} from './__generated__/GetMarketplaceListingFeatureTypeIdsV2'

const QUERY = gql`
  query GetMarketplaceListingFeatureTypeIdsV2($id: String!) {
    marketplaceListingV2(id: $id) {
      ... on MarketplaceListingV2 {
        id
        featureTypeIds
      }
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetMarketplaceListingFeatureTypeIdsV2 = (id: string) =>
  useQuery<GetMarketplaceListingFeatureTypeIdsV2, GetMarketplaceListingFeatureTypeIdsV2Variables>(QUERY, {
    variables: { id },
    fetchPolicy: 'network-only'
  })
